import branchSdk from 'branch-sdk';
import { AppBar, Button, CircularProgress, Hidden, makeStyles, Toolbar, useMediaQuery } from '@material-ui/core';
import { ChatBubble } from '@material-ui/icons';
import { CustomToaster } from 'components/CustomToaster';
import ScrollToTop from 'components/ScrollToTop';
import isEmpty from 'lodash.isempty';
import { isJourneyVisibleState, openChatState, SUPPORT_CHAT } from 'pages/CustomerBooking';
import { useEffect, useMemo, useState } from 'react';
import { matchPath, Route, Switch, useLocation, useRouteMatch } from 'react-router-dom';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { useUserState } from 'services/authentication.service';
import { useTrackEvent } from 'util/trackEvent';
import { BookingCodeProcess } from '../BookingCodeProcess';
import { BookingConfirm } from '../Confirm';
import { BookingDetails } from '../Details';
import { BookingMapView } from '../Details/BookingMapView';
import { BookingNotFound } from '../Details/BookingNotFound';
import { PostBooking } from '../Details/PostBooking';
import { PostRating } from '../Details/PostRating';
import { OngoingJob } from '../OngoingJob';
import { PaymentScreen } from '../Payment';
import { ProviderProfile } from '../ProviderProfile';
import { Reschedule } from '../Reschedule';
import { Sidebar } from '../Stepper/Sidebar';
import { Wizard } from '../Stepper/Wizard';
import { Helmet } from "react-helmet";
import { bookingState } from '../RecoilState';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      height: '100%',
      width: '100vw',
    },
    layoutRoot: {
      width: '100%',
      height: '100%',
      background: theme.palette.background.paper,
    },
    overPad: {
      [theme.breakpoints.down("sm")]: {
        height: '64px',
      },
    },
    chatFooter: {
      top: 'auto',
      bottom: 0,
      backgroundColor: 'transparent'
    }
  }
})
const Layout = ({ match, onSetSvcId = () => { } }) => {
  const classes = useStyles()
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("xs"), {
    noSsr: true,
  });
  const { logout } = useUserState()
  const setChatOpen = useSetRecoilState(openChatState);
  const trackEvent = useTrackEvent()

  const pathCheck = {
    path: [
      '/bookings/login/:serviceId',
      '/bookings/oops/:serviceId',
      '/bookings/:serviceId/code/:code',
      '/bookings/:serviceId/',
    ],
    strict: false,
    sensitive: true
  }
  const isRouteSvc = useRouteMatch(pathCheck)
  const location = useLocation()

  const serviceId = match?.params?.serviceId
  const booking = useRecoilValue(bookingState);

  const [svcId, setSvcId] = useState(isRouteSvc?.params?.serviceId);
  useEffect(
    () => {
      const match = matchPath(location.pathname, pathCheck)
      console.log('index.jsx (103)', match)
      onSetSvcId(match?.params?.serviceId)
    }, [location]
  );

  const [isJourneyVisible, setIsJourneyVisible]= useRecoilState(isJourneyVisibleState);
  
  useEffect(
    () => {
      branchSdk?.addListener('didShowJourney', (evt, data) => {
        setIsJourneyVisible(true);
      });
      branchSdk?.addListener('didCloseJourney', () => {
        setIsJourneyVisible(false);
      });
    }, []
  );

  const renderTitle = useMemo(
    () => {
      const truncateID = serviceId?.substring(serviceId?.length - 4)
      return (
        <Helmet>
          <title>
            {`Zennya Health - ${booking?.white_label_partner?.label ?? ''} Booking (${truncateID})`}
          </title>
          <meta
            name="description"
            content={`Zennya Health - ${booking?.white_label_partner?.label ?? ''} Booking (${truncateID})`}
          />
        </Helmet>
      )
    }, [booking?.white_label_partner?.label, serviceId]
  );

  const Routes = useMemo(() => {
    return (
      <div className={classes.layoutRoot}>
        <ScrollToTop />
        <Switch>
          <Route exact path="/bookings/:serviceId/code/:code" component={BookingCodeProcess} />
          <Route exact path="/bookings/:serviceId/reschedule">
            <Reschedule asView />
          </Route>
          <Route exact path="/bookings/:serviceId/rebooking">
            <Reschedule asView rebook />
          </Route>
          <Route exact path="/bookings/:serviceId/location" component={BookingConfirm} />
          <Route exact path="/bookings/:serviceId/map" component={BookingMapView} />
          <Route exact path="/bookings/:serviceId/payment" component={PaymentScreen} />
          <Route exact path="/bookings/:serviceId/ongoing" component={OngoingJob} />
          <Route exact path="/bookings/:serviceId/rating" component={PostRating} />
          <Route exact path="/bookings/:serviceId/results" component={PostBooking} />
          <Route exact path="/bookings/:serviceId/providerProfile" component={ProviderProfile} />
          <Route path="/bookings/:serviceId" component={BookingDetails} />
{/* 
          <Route>
            <BookingNotFound />
          </Route> */}
        </Switch>
        <div className={classes.overPad} />
      </div>
    )
  }, [classes.layoutRoot, classes.overPad]);


  return (
    <div className={classes.root}>
      {renderTitle}
      <CustomToaster
        onChatOpen={() => {
          setChatOpen(SUPPORT_CHAT)
        }}
      />
      <Hidden smUp>
        <Wizard
          onLogout={() => {
            logout(match?.params?.serviceId, {})
          }}
          isMobile serviceId={match?.params?.serviceId} current={1} >
          {Routes}
        </Wizard>
      </Hidden>
      <Hidden xsDown>
        <Sidebar serviceId={match?.params?.serviceId} current={1} >
          {Routes}
        </Sidebar>
      </Hidden>
      {/* {(!isMobile && chatOpen !== CLOSE_CHAT) && <SquarePopUp fixed />} */}
      {isMobile && (
        <AppBar elevation={0} className={classes.chatFooter}>
          <Toolbar>
            <Button className={classes.support} variant="contained" fullWidth color="secondary" onClick={() => {
              trackEvent('Chat Mobile Bubble - clicked', { 'type': SUPPORT_CHAT })
              setChatOpen(SUPPORT_CHAT)
            }}><ChatBubble />Support Chat</Button>
          </Toolbar>
        </AppBar>
      )}
    </div>
  )
}

const RecoilWrapper = (props) => {
  const { match } = props

  if (isEmpty(match?.params?.serviceId)) {
    return <CircularProgress />
  }
  return (
    <>
      {/* <BookingCodeProcess serviceId={match?.params?.serviceId} /> */}
      <Layout {...props} />
    </>
  )
}
export { RecoilWrapper as Layout };
